const clothing = [
  {
    link: '/clothing/',
    name: "What's hot",
    type: 'filter'
  },
  {
    link: '/clothing/?sort=release_date_desc',
    name: 'Latest releases',
    type: 'filter'
  },
  { icon: 'adidas', name: 'adidas', slug: 'adidas', type: 'brand' },
  { icon: 'carhartt', name: 'Carhartt', slug: 'carhartt', type: 'brand' },
  {
    icon: 'coleBuxton',
    name: 'Cole Buxton',
    slug: 'cole-buxton',
    type: 'brand'
  },
  { icon: 'corteiz', name: 'Corteiz', slug: 'corteiz', type: 'brand' },
  {
    icon: 'fearOfGod',
    name: 'Fear Of God ESSENTIALS',
    slug: 'fear-of-god-essentials',
    type: 'brand'
  },
  { icon: 'montirex', name: 'Montirex', slug: 'montirex', type: 'brand' },
  {
    icon: 'newBalance',
    name: 'New Balance',
    slug: 'new-balance',
    type: 'brand'
  },
  {
    icon: 'nike',
    name: 'Nike',
    slug: 'nike',
    type: 'brand'
  },
  { icon: 'represent', name: 'Represent', slug: 'represent', type: 'brand' },
  { icon: 'stussy', name: 'Stüssy', slug: 'stussy', type: 'brand' },
  {
    icon: 'theNorthFace',
    name: 'The North Face',
    slug: 'the-north-face',
    type: 'brand'
  },
  { icon: 'uniqlo', name: 'Uniqlo', slug: 'uniqlo', type: 'brand' }
];

export default clothing;
